import { useContextOrThrow } from '@deephaven/react-hooks';
import { ChartThemeContext } from "./ChartThemeProvider.js";
/**
 * Hook to get the current `ChartThemeContextValue`.
 */
export function useChartTheme() {
  return useContextOrThrow(ChartThemeContext, 'No ChartThemeContext value found.');
}
export default useChartTheme;
//# sourceMappingURL=useChartTheme.js.map